(function(){
var raiz=document.getElementById('vv-intl'); if(!raiz) return;
var LISTA=(raiz.dataset.lista||'').split(',').filter(Boolean); if(!LISTA.length) return;
var CLAVE='vv_intl_visto', ov=null;
var FORZADO=new URLSearchParams(location.search).get('vv_pais');
function detectar(){
if(FORZADO) return Promise.resolve(FORZADO.toUpperCase());
var liq=(raiz.dataset.liquid||'').toUpperCase();
if(liq&&LISTA.indexOf(liq)!==-1) return Promise.resolve(liq);
return fetch('/browsing_context_suggestions.json').then(function(r){return r.ok?r.json():null;}).then(function(d){var c=d&&d.detected_values&&d.detected_values.country;return c&&c.handle?c.handle.toUpperCase():liq;}).catch(function(){return liq;});
}
function copiar(b){
if(!b) return;
var cod=b.getAttribute('data-codigo')||'';
function ok(){var s=b.querySelector('span');if(s){s.textContent='Copiado!';}b.classList.add('vv-copied');}
if(navigator.clipboard&&cod){navigator.clipboard.writeText(cod).then(ok).catch(function(){ok();});}
else{try{var t=document.createElement('textarea');t.value=cod;t.setAttribute('readonly','');t.style.position='absolute';t.style.left='-9999px';document.body.appendChild(t);t.select();document.execCommand('copy');document.body.removeChild(t);ok();}catch(e){}}
}
function revelar(btn){
var caja=btn.parentNode.querySelector('[data-vv-code]');
if(!caja) return;
caja.hidden=false;
btn.style.display='none';
var cod=btn.getAttribute('data-codigo')||'';
if(navigator.clipboard&&cod){try{navigator.clipboard.writeText(cod);}catch(e){}}
}
function abrir(cod){
if(ov) return;
var tpl=raiz.querySelector('template[data-pais="'+cod+'"]'); if(!tpl) return;
ov=document.createElement('div'); ov.id='vv-ov';
ov.setAttribute('role','dialog'); ov.setAttribute('aria-modal','true');
var caja=document.createElement('div'); caja.className='vvm';
caja.appendChild(tpl.content.cloneNode(true));
ov.appendChild(caja); document.body.appendChild(ov);
document.body.style.overflow='hidden';
ov.addEventListener('click',function(e){if(e.target===ov)cerrar();});
caja.querySelectorAll('[data-vv-cerrar]').forEach(function(b){b.addEventListener('click',cerrar);});
caja.querySelectorAll('[data-vv-revelar]').forEach(function(b){b.addEventListener('click',function(){revelar(b);});});
caja.querySelectorAll('[data-vv-copiar]').forEach(function(b){b.addEventListener('click',function(){copiar(b);});});
document.addEventListener('keydown',esc);
try{sessionStorage.setItem(CLAVE,'1');}catch(e){}
}
function cerrar(){if(!ov)return;ov.remove();ov=null;document.body.style.overflow='';document.removeEventListener('keydown',esc);}
function esc(e){if(e.key==='Escape')cerrar();}
function fab(cod){
var tpl=raiz.querySelector('template[data-pais="'+cod+'"]'); if(!tpl) return;
var b=tpl.content.querySelector('.vvm__flag');
var el=document.createElement('button'); el.id='vv-fab'; el.type='button';
el.setAttribute('aria-label','Informacion de envio a tu pais');
el.innerHTML='<span class="f">'+(b?b.textContent.trim():'')+'</span><span class="vv-fabtxt">Envío</span>';
el.addEventListener('click',function(){abrir(cod);});
document.body.appendChild(el);
}
var MIN_ON=raiz.dataset.min==='true';
var MIN_CENT=parseInt(raiz.dataset.mincent,10)||5000;
var MIN_MSG=raiz.dataset.minmsg||'Te faltan {falta} para la compra minima de {min}.';
var MIN_PAISES=(raiz.dataset.minpaises||'').split(',').map(function(s){return s.trim();}).filter(Boolean);
if(!MIN_PAISES.length) MIN_PAISES=['BZ','CR','GT','HN','NI','PA','SV','AR','BO','BR','CL','CO','EC','GY','PY','PE','SR','UY','VE'];
var SEL_CHK='[name="checkout"],button[name="checkout"],.cart__checkout,.cc-cart__checkout,.cart-drawer__checkout,[data-checkout-button],a[href$="/checkout"],a[href*="/checkout?"],#_rsi-buy-now-button,._rsi-buy-now-button,[id^="_rsi-buy-now"]';
var cartTotal=null;
function money(c){return '$'+(c/100).toFixed(2);}
function pintarMin(){
if(cartTotal===null) return;
var falta=MIN_CENT-cartTotal;
var bloq=(cartTotal>0)&&(falta>0);
var txt=MIN_MSG.replace('{falta}','<b>'+money(falta)+'</b>').replace('{min}','<b>'+money(MIN_CENT)+'</b>');
document.querySelectorAll(SEL_CHK).forEach(function(b){
if(bloq){b.style.opacity='.45';b.style.pointerEvents='none';b.setAttribute('aria-disabled','true');b.dataset.vvmin='1';}
else if(b.dataset.vvmin){b.style.opacity='';b.style.pointerEvents='';b.removeAttribute('aria-disabled');delete b.dataset.vvmin;}
var host=b.parentNode; if(!host) return;
var a=host.querySelector('.vvmin-aviso');
if(bloq){ if(!a){a=document.createElement('div');a.className='vvmin-aviso';host.insertBefore(a,b);} a.innerHTML=txt; a.style.display='block'; }
else if(a){ a.style.display='none'; }
});
}
function refrescarMin(){return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){cartTotal=c.total_price;pintarMin();return c;}).catch(function(){});}
function iniciarMin(cod){
if(!MIN_ON||MIN_PAISES.indexOf(cod)===-1) return;
if(raiz.dataset.minexpress==='true'){document.documentElement.classList.add('vv-min-express');}
refrescarMin();
var of=window.fetch;
window.fetch=function(){var p=of.apply(window,arguments);try{var u=arguments[0];u=(u&&u.url)||u||'';if(typeof u==='string'&&/\/cart\/(add|change|update|clear)/.test(u)){p.then(function(){setTimeout(refrescarMin,300);});}}catch(e){}return p;};
document.addEventListener('click',function(e){
var t=(e.target&&e.target.closest)?e.target.closest(SEL_CHK):null; if(!t) return;
if(cartTotal!==null&&cartTotal>0&&cartTotal<MIN_CENT){e.preventDefault();e.stopImmediatePropagation();refrescarMin();}
},true);
setInterval(refrescarMin,2500);
}
detectar().then(function(cod){
if(!cod) return;
iniciarMin(cod);
if(LISTA.indexOf(cod)===-1) return;
if(raiz.dataset.ocultachat==='true'){document.documentElement.classList.add('vv-latam');}
fab(cod);
var visto=false; try{visto=sessionStorage.getItem(CLAVE)==='1';}catch(e){}
if(FORZADO) visto=false;
if(raiz.dataset.auto==='true'&&!visto){setTimeout(function(){abrir(cod);},parseInt(raiz.dataset.espera,10)*1000||3000);}
});
})();
